export default "__VITE_ASSET__BBr02YQU__"